import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import { useMutation } from '@tanstack/react-query';
import { useBoolean } from 'ahooks';
// eslint-disable-next-line no-restricted-imports
import { Form } from 'antd';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { UserAPI } from 'api/user';
import { ErrorMessage, LinkText, UserInfo } from 'components/atoms/form-elements';
import { Button } from 'components/facade/button';
import { Input } from 'components/facade/input';
import { Container, Heading, HeadingContainer, HelperTitle, TextContainer, WelcomeHeading } from 'components/organisms/login/login-layout';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { useAccountMetaQuery } from 'queries';
import { CompanyLogo } from 'routes/auth/common/company-logo';
import { SuccessPage } from './customer-login-success';
const RecoveryButton = styled(Button)`
  margin: var(--spacing-03) 0;
  width: 100%;
  background: var(--blue-70);
`;
const StyledForm = styled(Form)`
  width: 400px;
`;
export const CustomerLogin = ()=>{
    const [form] = Form.useForm();
    const [email, setEmail] = useState('');
    const request = (_email)=>UserAPI.getMagicLink(_email);
    const [isSuccess, { setTrue }] = useBoolean(false);
    const { isLoading: loading, mutateAsync: handleClick, isError: isEmailSentFailed } = useMutation(request, {
        onSuccess: ()=>{
            setTrue();
        }
    });
    const onSubmit = useCallback(async ()=>{
        const { email: _email } = await form.validateFields();
        setEmail(_email);
        handleClick(_email);
    }, [
        form,
        handleClick
    ]);
    const translatedPlaceholderText = useTranslation('forgot_password.email');
    const requiredText = useTranslation('forgot_password.email_required');
    const { data } = useAccountMetaQuery();
    if (isSuccess) {
        return /*#__PURE__*/ _jsx(SuccessPage, {
            email: email
        });
    }
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsxs(HeadingContainer, {
                children: [
                    data && /*#__PURE__*/ _jsx(CompanyLogo, {
                        data: data.company
                    }),
                    /*#__PURE__*/ _jsxs(TextContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(WelcomeHeading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "welcome"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Heading, {
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "login.title",
                                    values: {
                                        companyName: data === null || data === void 0 ? void 0 : data.company.companyName
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(HelperTitle, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "sent_email_link_to_access_portal"
                })
            }),
            /*#__PURE__*/ _jsxs(StyledForm, {
                form: form,
                layout: "vertical",
                onSubmitCapture: onSubmit,
                onFinish: onSubmit,
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "email",
                        label: translatedPlaceholderText,
                        rules: [
                            {
                                required: true,
                                message: requiredText
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Input, {
                            type: "email",
                            placeholder: translatedPlaceholderText
                        })
                    }),
                    /*#__PURE__*/ _jsx(ErrorMessage, {
                        children: isEmailSentFailed ? 'Something went wrong. Please try again.' : ''
                    }),
                    /*#__PURE__*/ _jsx(RecoveryButton, {
                        loading: loading,
                        type: "primary",
                        onClick: onSubmit,
                        size: "large",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "email_signin_link"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(UserInfo, {
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "forgot_password.cta_back",
                    values: {
                        a: (chunks)=>/*#__PURE__*/ _jsx(Link, {
                                to: RoutePaths.login,
                                children: /*#__PURE__*/ _jsx(LinkText, {
                                    children: chunks
                                })
                            })
                    }
                })
            })
        ]
    });
};
